export default {
  userProfile: {
    header: {
      title: "Configuración del perfil",
      subtitle: "Administra tu perfil de Linemate",
    },
    sections: {
      accountDetails: "Detalles de la cuenta",
      billing: "Facturación",
    },
    labels: {
      oldPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirmar nueva contraseña",
      enterYourPassword: "Ingresa tu contraseña",
      showAll: "Mostrar todo",
    },
    descriptions: {
      changePassword: "Cambia la contraseña de tu cuenta de Linemate",
      preferredOdds: "Elige tus cuotas preferidas para tendencias y Mis picks",
      language: "Selecciona el idioma en el que quieres ver Linemate.",
      odds: "Selecciona el formato en el que quieres que se muestren las cuotas.",
      theme: "Selecciona cómo se muestra Linemate.",
      billingPrimary: "Consulta tu plan y las opciones de pago",
      billingSecondary: "Linemate trabaja con Stripe para simplificar la facturación y la administración de pagos.",
      deleteAccount: "Elimina tu cuenta y los datos de tu cuenta",
      deleteAccountSecondary: "Si quieres eliminar permanentemente tu cuenta, puedes hacerlo a la derecha.",
    },
    actions: {
      update: "Actualizar",
      choosePreferredOdds: "Elegir cuotas preferidas",
      saveMyChoices: "Guardar mis elecciones",
      manageBilling: "Administrar facturación",
      deleteThisAccount: "Eliminar esta cuenta",
    },
    deleteAccount: {
      confirmMessage: "¿Seguro que quieres eliminar tu cuenta? Si es así, continúa abajo.",
      permanentWarning: "Ten en cuenta que todos tus datos se eliminarán permanentemente de nuestros servidores. Esta acción finalizará tu suscripción para el próximo período de facturación y no se puede deshacer.",
      acknowledgment: "Reconozco que todos los datos de esta cuenta se eliminarán y quiero continuar.",
    },
    validation: {
      passwordRequirements: "La contraseña debe incluir una letra mayúscula, una letra minúscula y tener al menos 8 caracteres.",
      confirmPasswordMismatch: "La confirmación de la contraseña no coincide.",
      incorrectPassword: "Contraseña incorrecta.",
    },
  },
};